import * as React from 'react';
import { useRef, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import { startTimeline } from '@src/utils/x-ani';
import { X_ANI_CONFIG } from './animation';
import BaseSwiper from '@src/components/swiper/base-swiper';
import cx from 'classnames';
import Link from '@src/components/link';
import BackgroundImage from '@src/components/background-image';
import { DOWNLOAD_URL } from '@src/constants/business';
const styles = require('./index.less');

export default wrapStore(({ store, isActive }) => {
  store.use();
  const ctxRef = useRef(null);

  useEffect(
    () => {
      if (!ctxRef.current) {
        ctxRef.current = startTimeline(X_ANI_CONFIG, '#downloadSection');
      } else {
        if (isActive) {
          ctxRef.current.restart();
        } else {
          ctxRef.current.reverse();
        }
      }
    },
    [isActive]
  );

  return (
    <section id="downloadSection" className={styles.downloadSectionRoot}>
      {/* 下载安装区域 */}
      <div className={styles.downloadContent}>
        <div className={styles.downloadInner}>
          <Link className={styles.nextBtn} onClick={store.goNext} />
          <Link className={styles.prevBtn} onClick={store.goPrev} />
          <div className={styles.downloadList}>
            <BaseSwiper store={store.baseSwiperStore}>
              {store.downloadList.map(item => (
                <div key={item.title} className={styles.stepImg}>
                  <BackgroundImage src={item.image} mergeStyle={{ backgroundSize: '100% 100%' }} />
                </div>
              ))}
            </BaseSwiper>
          </div>
        </div>
        <div className={styles.pagination}>
          {store.downloadList.map((item, index) => (
            <Link
              onClick={() => store.baseSwiperStore.onChange(index)}
              key={item.title}
              className={cx(styles.paginationItem, styles[`paginationItem${index}`], { [styles.isActive]: index === store.activeIndex })}
            />
          ))}
        </div>
        <div className={styles.description}>
          {store.downloadList[store.activeIndex].isButton && <Link href={DOWNLOAD_URL} className={styles.btnDownload} />}
          <img src={store.downloadList[store.activeIndex].description} alt={store.downloadList[store.activeIndex].title} />
        </div>
      </div>
      {/* 关注我们区域 */}
      <div className={styles.followContent}>
        {store.followList.map(item => (
          <div key={item.title}>
            <img
              src={item.image}
              alt={item.title}
              className={item?.link && styles.pointStyle}
              onClick={() => {
                store.onLinkClick(item.type, item.link);
              }}
            />
          </div>
        ))}
      </div>
      {/* 版权信息区域 */}
      <div className={styles.copyrightBtn} onClick={store.showCopyright} />
    </section>
  );
}, Store);
